<template>
  <div ref="expCard" :class="'expertCard'+showWide">
    <div class="lhs">
   <div  class="drag cardTitle" style="box-shadow: inset 0px 0px 10px 2px;"><span :class="isNew" style="pointer-events:none;">{{expert.name}}</span></div>
  
   <div class="expertDetails">
    
     <GlowImage v-if="expert" :image="expert" :style="style" :label="expert.role" @click.native="click"></GlowImage>
     <img class="expertAudio" v-if="isTalking" src="../assets/voice/Aston_01L.gif" width=200px height=80px>
       <div v-if="false" style="position:absolute;left:0px;width:210px;text-align:center;line-height:16px;">{{expert.role}}</div>
       </div>
 <slot></slot>
 <div v-if="isOpen" class="ExpertTalk">
   
    
    
    <div v-if="actionList && currentItem<actionList.length">
      <Speach @speechEnded="doEndSpeech" ref="speech" :audio="expertAudio" :textToSpeak="expertWords" :charVoiceIndex="voiceIndex" :textPrompt="''"></Speach>
      
      <div class="talkPromptGreen" v-if="!isTalking" @click="talkTo()"   >{{actionItem(actionList[currentItem]).text}} 
      </div>
      <div class="talkPrompt" v-else @click="talkTo()" style="opacity:0.8;" >{{actionItem(actionList[currentItem]).text}} 
      </div>
    </div>
    <div v-else>
        {{endMessage}}
        <div class="talkPrompt" style="margin:auto; margin-top: 10px; width:150px;text-align:center;" @click="replayCard">Replay</div>
        <div v-if="expert && expert.scene" class="sceneBtn" @click="showScene(expert.scene)">
            Scene Unlocked
           </div>
      </div>
   <div class="voiceOver" v-if="expert && isTalking">{{expertWords}}</div>
    <div v-if="!actions && !playing" @click="playAudio">Message</div>
     
   
   <audio
     ref="audio1"
     :src="audioFile"
      @ended="doEnd"
     >
   </audio>
   
    <av-line v-show="playing"
      ref-link="audio1"
      :line-width="1"
      :canv-width="200"
      :canv-height="50"
      line-color="#0033bb"
     
    ></av-line>
  
    <!--  <av-waveform
      ref-link="audio1"
       audio-src="/voice/documents.mp3"
    ></av-waveform>
     -->
     </div>
     </div>
     <div class="expertBtns">
     <div :class="'basicBtn '+isNew" v-if="!isOpen" @click="click">View Expert</div>
   <div class="basicBtn" v-else @click="click">Close Panel</div>
   </div>
  </div>
</template>

<script>
import notify from 'devextreme/ui/notify';
import gsap from "gsap";
import axios from 'axios'
import AudioVisual from 'vue-audio-visual'
import GlowImage from "@/components/GlowImage.vue";
import Nodes from "@/mixins/nodes"
import Speach from '@/components/Speach'
export default {
  mixins:[Nodes],
  components:{
    AudioVisual,
    GlowImage,
    Speach
  },
  props: {
    card:null,
    index:null,
    selected:{default:false},
    isOpenX:{default:false},
    
  },
  data() {
    return {
      isTalking:false,
      isOpen:false,
      currentItem:0,
      messages:[
        require('../assets/static/voice/documents.mp3'),
        require('../assets/static/voice/FoundExpert.mp3'),
        require('../assets/static/voice/interestedArticle.mp3'),
        require('../assets/static/voice/moreResearch.mp3'),
      ],
      playing:false,
       //expert:{name:"Tammy Tangarum",id: "exp20" },
      style:"opacity:.9;width:180px;height:180px;border-radius:50%;text-transform: uppercase;",
      animation: {
        hide:{ type: 'slide', duration: 1000, to:{ position: {  
              my: 'top left',  
              at: 'top right',  
              of: window,  
              offset: '0 0'  
          }}},
        show:{ type: 'slide', duration: 1000, from:{ position: {  
              my: 'top left',  
              at: 'top right',  
              of: window,  
              offset: '0 0'  
          }} }
        }
    };
  },
  mounted(){
   
    console.log("Mounted expert",this.expert,this.card)
  },
  computed: {
     fireBaseLoc(){
					return this.$store.getters.getFireBaseLoc					
			},
    viewedDocs(){
      return this.$store.getters.getViewedDocs
      
    },
    isNew(){
       if(this.viewedDocs.includes(this.card.id)){
        this.card.read=true
      }
     if(!this.card.read){
       return "unread"
     }
    },
     windowHeight(){
      return window.innerHeight
    },
    windowWidth(){
      return window.innerWidth
    },
    endMessage(){
       if(this.expert && this.expert.EndMessage){
            return this.expert.EndMessage
       }
    },
    expertAudio(){
       if(this.expert && this.expert.audio){
         if(this.expert.audio[this.currentItem] ){ 
           return this.fireBaseLoc+this.expert.audio[this.currentItem]
         }
        return this.fireBaseLoc+this.expert.audio
       }
    },
    expertWords(){
      if(this.expert){
        if(this.expert.VO[this.currentItem] ){
          return this.expert.VO[this.currentItem]
        }
        return this.expert.VO
      }
      return "Nothing to say"
    },
     voiceIndex(){
      if(this.expert){
        return this.expert.VoiceIndex
      }
      
    },
    actions(){
      return this.expert.actions
    },
    actionList(){
      if(this.expert){
        return this.getActions(this.expert.actions)
      }
    },
    showWide(){ 
      if(this.isOpen){
        return " fullSize"
      }else{
        return ""
      }
      //return "fullSize"
    },
   audioFile(){

     return this.messages[Math.floor(Math.random()*this.messages.length)]
     //return FoundExpert.mp3
   },
   expert(){
     return this.$store.getters.getExpert(this.card.id)
   },
   infoList(){
      if(this.expert && this.expert.info){
        console.log("INFO",this.expert.info)
        return this.getInfo(this.expert.info)
      }
    },
  },
  methods: {
    replayCard(){
      this.currentItem=0
    },
     showScene(scene){
       console.log("Set Cut Scene",scene)
      this.$store.commit("setCutScene",scene)
    },
    doEndSpeech(){
      this.isTalking=false
      this.doAction(this.actionItem(this.actionList[this.currentItem]))
    },
    talkTo(action){
      this.isTalking=true
      this.$refs.speech.talk()
      
    },
    doEnd(){
      this.playing=false
    },
    playAudio(){
      //this.isOpen=true
      this.playing=true
      this.$refs.audio1.play(0)
    },
    click(){
      this.$emit('click',this.index)
      //showWide
      //if(this.selected){
      if(this.isOpen){
        this.isOpen=false
      }else{
        this.isOpen=true
        this.$set(this.expert,'read',true)
        this.$set(this.card,'read',true)
      }
      //}
      //this.$emit('click',this.index)
    }
  },
  watch:{
    isOpen(val){
     
      console.log("EXP CARD",this.$refs.expCard.getBoundingClientRect().left)
      this.$store.commit('readDoc',this.expert)
      
      
      if(val){
        this.$set(this.card,'width',700)
       //this.$set(this.card,'height',300)
          let docMidX=this.$refs.expCard.getBoundingClientRect().left+700/2
          let docMidY=this.$refs.expCard.getBoundingClientRect().top+300/2
          console.log(this.windowWidth/2,docMidX)
          this.$emit("moveCardLeft",-(this.windowWidth/2-docMidX+25))
          this.$emit("moveCardTop",-(this.windowHeight/2-docMidY)-20) 
      }else{
        this.$set(this.card,'width',180)
        //this.$set(this.card,'height',300)
         this.$emit("resetCardPos")
      }
      
    },
    selected(val){
      if(!val){
        //this.isOpen=false
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/sass/variables.scss";
.expertCard{
  text-align: center;
  width: 207px;
  height: 340px;
  top:0px;
  left:8px;
  border: solid 3px #0bf;
 box-shadow: 0px 0px 20px 0px,0px 0px 20px 0px inset ;
  color: #0bf;
  line-height: 30px;
  position: absolute;
   background:$glow-Gradient-trans;
  /*background: linear-gradient(#006677 1px, #003 1px);*/
   background-size: 100% 5px;
   .unread{
      color:#0efb0c;
   }
   .expertAudio{
    display:none

  }
  
}
.expertCard .drag {
   margin-bottom:7px;
    -webkit-box-shadow: inset 0px 0px 50px 0px;
    box-shadow: inset 0px 0px 5px 0px;
    border-bottom: solid 3px #0bf;
    background-color: #002a3377;
    line-height: 24px;
}
.expertCard.fullSize{
  width:770px;
  height:360px;
  text-align:left;
  z-index:1000;
  .expertAudio{
    display:block;
   position:absolute;
   top:144px;
   left:20px

 }
  .expertDetails{
    width:210px;
    display:inline-block;
    margin-left:20px;
  }
  .ExpertTalk{
    color:#00ffff;
    position: absolute;
    display: inline-block;
    margin-left: 15px;
    margin-right: 15px;
    overflow-y: auto;
    width: calc(100% - 270px);
  }
  
  .talkPromptGreen{
    color:#0efb0c;
    border:#0efb0c solid;
    text-align: center;
    border-radius: 5px;
    font-weight:500;
    cursor: pointer;
    background-color: #0efb0c33;
    padding: 0px 5px;
    margin-top: 10px;
  
  }
  .talkPromptGreen:hover{
     background-color: #10fb0c5e;
  }
  .talkPrompt{
    color: orange;
    border: orange solid;
    text-align: center;
    border-radius: 5px;
    font-weight:500;
    cursor: pointer;
    background-color: #ff770033;
    padding: 0px 5px;
    margin-top: 10px;
  
  }
  .talkPrompt:hover{
     background-color: #ff770077;
  }
  .voiceOver{
    height: 240px;
    overflow-y: auto;
  }
}

.expertCard:hover {
    border: solid 3px $glow-text-colour-selected;
    box-shadow: inset 0px 0px 20px 0px;
    color: #0bf;
    background: linear-gradient(#006677 1px, #003 1px);
    background-size: 100% 5px;
  }
 .expertCard .drag:hover {
  
    background-color: #00ffff2e;
    -webkit-box-shadow: inset 0px 0px 20px -5px;
    box-shadow: inset 0px 0px 20px -5px;
    
    border-bottom: solid 3px $glow-text-colour-selected;
 }
 
 .expertBtns{
   position:absolute;
   bottom:10px;
   width:100%;
   text-align:center;
 }
 
 .cardTitleX{
  text-align:center;
  text-transform: uppercase;
    font-size: 17px;
    padding: 2px 5px;
}
</style>